import styled from 'styled-components';
import themedColor from '../../../styles/theme/themed-color';
import styleUtils from '../../../styles/style.utils';
import themedFontSize, {
  THEMED_FONT_SIZE_TYPES,
  ThemedFontSizeReturn
} from '../../../styles/theme/themed-font-size';
import Text from '../text/text';

interface ContainerProps {
  height: number;
  borderRadius: number;
  padding: number;
  margin: number;
}

const Container = styled.div<ContainerProps>`
  border: solid ${themedColor('TEXT_BLUE')} ${styleUtils.px(1)};
  border-radius: ${styleUtils.px(25)};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props: ContainerProps): string =>
    styleUtils.px(props.height || 50)};
  padding: ${(props: ContainerProps): string =>
    styleUtils.px(props.padding || 16)};
  margin: 0
    ${(props: ContainerProps): string => styleUtils.px(props.margin || 8)};
  flex: 1;
  cursor: pointer;
`;

interface StyledTextProps {
  fontSize: keyof typeof THEMED_FONT_SIZE_TYPES;
}
const StyledText = styled(Text)<StyledTextProps>`
  &.ucf-paragraph {
    color: ${themedColor('TEXT_BLUE')};
    margin-bottom: 0;
    font-size: ${(props: StyledTextProps): ThemedFontSizeReturn =>
      themedFontSize(props.fontSize || 'BUTTON_M')};
    letter-spacing: normal;
  }
`;

const ButtonComponents = { Container, StyledText };
export default ButtonComponents;
